import { DownloadService } from '@qality/common-service';

import { sampleCsv } from './sample_csv_data.js';

const EXAMPLE_CSV_FILE_NAME = 'qality_import_example_csv.csv';
const allowedTypes = ['number', 'string', 'user', 'array', 'option'];
const allowedArrays = ['number', 'string', 'component', 'version', 'option'];
const omitKeys = [
  'summary', // renamed to TestCase.Name
];

export const QAlityOptions = [
  { label: 'Test Case Name', value: 'TestCase.Name', required: true },
  { label: 'Test Step', value: 'TestStep.Step', required: true }, // one sa w bazie
  { label: 'Expected Result', value: 'TestStep.Result', required: true }, // one sa w bazie
];

export const getQAlityFields = (fields = {}) => {
  return Object.values(fields)
    .map((fieldDefinition) => {
      return {
        label: generateName(fieldDefinition),
        value: fieldDefinition.key,
        type: fieldDefinition.schema.type,
        arrayType: fieldDefinition.schema.items, // null if not an array
        required: fieldDefinition.hasDefaultValue
          ? false
          : fieldDefinition.required,
      };
    })
    .filter((fieldDefinition) => {
      if (omitKeys.includes(fieldDefinition.value)) {
        return false;
      }
      if (allowedTypes.includes(fieldDefinition.type)) {
        if (fieldDefinition.type === 'array') {
          return allowedArrays.includes(fieldDefinition.arrayType);
        }
        return true;
      }
    });
};

const generateName = (fieldDefinition) => {
  if (fieldDefinition.schema.type === 'user') {
    return `${fieldDefinition.name} (accountId)`;
  }
  return fieldDefinition.name;
};

export const downloadExampleCSV = async () => {
  DownloadService.downloadTxtFile(EXAMPLE_CSV_FILE_NAME, sampleCsv);
};
